






































import { Component, Vue } from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import * as amplitude from 'amplitude-js';
import { clientsModule } from '@/store';
import services from '@/services';
import { UserFileDTO } from '@/api';
import Upload from '@/components/common/Upload.vue';

import { canvastoFile, imagetoCanvas } from 'image-conversion';
import { loadImage } from '@/utils/canvas';

@Component({
  name: 'files-page',
  components: {
    BaseLayout,
    Upload,
  },
})
export default class FilesPage extends Vue {
  loading = false;

  modalLoading = false;

  files: UserFileDTO[] = []

  imageIndex: null | number = null;

  created() {
    if (this.client && this.client.id != null) {
      amplitude.getInstance().logEvent('Load client files');
      services.filesApi().filesEndpointGetUserFiles(this.client.id)
        .then(({ data }) => data)
        .then((files) => {
          this.files = files;
          return files;
        });
    }
  }

  get client() {
    return clientsModule.model;
  }

  saveFiles(files: File[]) {
    files.forEach((file) => {
      if (this.client && this.client.id != null) {
        this.$prompt('Введите комментарий', 'Добавление файла', {
          confirmButtonText: 'Сохранить',
          cancelButtonText: 'Отмена',
        })
          .then(async (msg) => {
            const comment = typeof msg === 'string' ? '' : msg.value;
            return services.filesApi()
              .filesEndpointStoreFile(undefined, comment, this.client?.id, file.name, file);
          })
          .then(({ data }) => data)
          .then((fileResp) => {
            const index = this.files.findIndex(f => f.id === fileResp.id);
            if (index > -1) {
              this.files.splice(index, 1, fileResp);
            } else {
              this.files.unshift(fileResp);
            }
          });
      }
    });
  }

  editFile(file: UserFileDTO, blob: Blob | File) {
    return services.filesApi()
      .filesEndpointStoreFile(file.id, file.description, this.client?.id, `t${new Date().valueOf()}-${file.name}`, blob)
      .then(({ data }) => {
        const index = this.files.findIndex(f => f.id === file.id);
        this.files.splice(index, 1, data);
      });
  }

  deleteFile(id: number) {
    services.filesApi().filesEndpointDeleteFile(id).then(() => {
      const index = this.files.findIndex(file => file.id === id);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    });
  }

  async rotateRight(id: number) {
    this.modalLoading = true;
    try {
      const file = this.files.find(f => f.id === id);
      if (file?.link) {
        const img = await loadImage(file.link);
        const canvas = await imagetoCanvas(img, { orientation: 6 });
        const blob = await canvastoFile(canvas);
        this.editFile(file, blob);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.modalLoading = false;
    }
  }

  async rotateLeft(id: number) {
    this.modalLoading = true;
    try {
      const file = this.files.find(f => f.id === id);
      if (file?.link) {
        const img = await loadImage(file.link);
        const canvas = await imagetoCanvas(img, { orientation: 8 });
        const blob = await canvastoFile(canvas);
        this.editFile(file, blob);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.modalLoading = false;
    }
  }
}
